import { createBrowserRouter, Navigate } from "react-router-dom";
import Login from "../pages/Login";
import ForgotPassword from "../pages/ForgotPassword";
import SignUp from "../pages/SignUp";
import SetPassword from "../pages/SetPassword";
import Dashboard from "../pages/Dashboard";
import { isLogin } from "../context/auth/auth.provider";
import GuestRoute from "../commons/GuestRoute";
import ProtectedRoute from "../commons/ProtectedRoute";
import TermsOfUse from "../pages/TermsOfUse";
import MyMaps from "../pages/MyMaps";
import Profile from "../pages/Profile";
import BuildAMap from "../pages/Map";
import MapToolboxProvider from "../context/mapToolbox/mapToolbox.provider";
import ImpersonateRedirection from "./impersonateRedirection";
import ErrorElement from "../component/Error";
import EditImage from "../pages/EditImage";
import UserManagement from "../pages/UserManagement";

const router = createBrowserRouter([
  {
    path: "/sign-in",
    element: (
      <GuestRoute>
        <Login />
      </GuestRoute>
    ),
  },
  {
    path: "/forgot-password",
    element: (
      <GuestRoute>
        <ForgotPassword />
      </GuestRoute>
    ),
  },
  {
    path: "/admin/user-management",
    element: (
      <ProtectedRoute>
        <UserManagement />
      </ProtectedRoute>
    ),
  },
  {
    path: "/admin/user/:action",
    element: (
      <ProtectedRoute>
        <SignUp />
      </ProtectedRoute>
    ),
  },
  {
    path: "/set-password",
    element: (
      <GuestRoute>
        <SetPassword />
      </GuestRoute>
    ),
  },
  {
    path: "/terms-of-use",
    element: (
      <GuestRoute>
        <TermsOfUse />
      </GuestRoute>
    ),
  },
  {
    path: "/map",
    element: (
      <ProtectedRoute>
        <MapToolboxProvider>
          <BuildAMap />
        </MapToolboxProvider>
      </ProtectedRoute>
    ),
    errorElement: <ErrorElement />,
  },
  {
    path: "/map/:id",
    element: (
      <ProtectedRoute>
        <MapToolboxProvider>
          <BuildAMap />
        </MapToolboxProvider>
      </ProtectedRoute>
    ),
    errorElement: <ErrorElement />,
  },
  {
    path: "/edit-image",
    element: (
      <ProtectedRoute>
        <MapToolboxProvider>
          <EditImage />
        </MapToolboxProvider>
      </ProtectedRoute>
    ),
    errorElement: <ErrorElement />,
  },
  {
    path: "/impersonate/:token",
    element: <ImpersonateRedirection />,
  },
  {
    path: "/",
    element: isLogin() ? (
      <Navigate replace to="/map" />
    ) : (
      <Navigate replace to="/sign-in" />
    ),
  },
  {
    path: "*",
    element: <Navigate replace to="/" />,
  },
]);

export default router;
